import React from 'react';

import PdfDownloadIcon from 'assets/pics/pdf-download.png';
import PropTypes from 'prop-types';

import { getBaseUrl } from 'utils/UrlUtil';

import './AssetDownloadItem.sass';

export const AssetDownloadItem = ({ asset, name }) => (
  <a className="asset-download-item col-xs-3" href={getBaseUrl() + asset} download>
    <img
      src={PdfDownloadIcon}
      alt="pdf-download"
      className="asset-download-item__pdf-download-img"
    />
    <div className="asset-download-item__name">{name}</div>
  </a>
);

AssetDownloadItem.displayName = 'AssetDownloadItem';

AssetDownloadItem.propTypes = {
  asset: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

AssetDownloadItem.defaultProps = {};
